<script>
    import leaflet from 'leaflet';
    import PickAPlace from 'svelte-pick-a-place';
    import {getContext, onMount} from "svelte";

    const { close } = getContext('simple-modal');

    export let index;
    export let lat;
    export let lng;
    export let setCoords = () => {};

    $ : selection = {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [parseFloat(lng), parseFloat(lat)]
        }
    }

    const saveCoord = (detail) => {
        const coordAsString = detail.geometry.coordinates[1] + ","  + detail.geometry.coordinates[0];
        setCoords(index, coordAsString);
        close();
    }
</script>

<PickAPlace
        leaflet={leaflet}
        zoom="6"
        selection={selection}
        lat={lat}
        lng={lng}
        selectionModes={['point']}
        on:save={({ detail }) => saveCoord(detail)}
        on:cancel={close}
/>
